import { useMonarchRule } from "@/monarch/rules/MonarchRulesProvider";
import {
  LogistrationTestData,
  LogistrationTestVariants,
  UseLogistrationTest,
} from "./types";

const CUSTOM_RULE_ID = "logistrationTest";

const useLogistrationTest: UseLogistrationTest = (): {
  isLoading: boolean;
  variant: LogistrationTestVariants;
} => {
  const { isLoading, value } = useMonarchRule<LogistrationTestData>(
    CUSTOM_RULE_ID,
    {},
  );

  if (isLoading) {
    return {
      isLoading,
      variant: "control",
    };
  }

  const variant: LogistrationTestVariants = value?.enableTest
    ? "test"
    : "control";

  return {
    isLoading,
    variant,
  };
};

export default useLogistrationTest;
